module.exports = function() {
  return new Worker(__webpack_public_path__ + "1dcaa9a7df873aab8ec8.worker.js");
};